<script>
export default {
  name: 'ModalSuccess',
  props: {
    signUpSuccessMsg: String
  },
  emits: ['closeSuccessModal'],
  setup (props, { emit }) {
    function overlayClickHandler (event) {
      if (event.target === event.currentTarget) {
        emit('closeSuccessModal')
      }
    }
    return {
      overlayClickHandler
    }
  }
}
</script>

<template>
  <div
    class="modal-auth__overlay"
    :class="{ open: signUpSuccessMsg }"
    @click="overlayClickHandler"
  >
    <div class="modal-auth">
      <div class="modal-auth__top">
        <div class="modal-auth__title">Запись подтверждена</div>
        <div
          class="modal-auth__close"
          @click.prevent="$emit('closeSuccessModal')"
        >
          <svg>
            <use xlink:href="/uploads/img/sprite.svg#icon-reset"></use>
          </svg>
        </div>
      </div>
      <div class="modal-auth__text">
        {{ signUpSuccessMsg }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal-auth {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10001;
  min-width: 320px;
  background-color: #fff;
  border-radius: 4px;
  padding: 30px;
  max-height: 90vh;
  border: 1px solid $blue-grey;
  display: flex;
  flex-direction: column;

  @media (max-width: 767px) {
    top: 45%;
    max-height: 85vh;
  }

  &__overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    background-color: rgba(0, 40, 86, 0.8);
    display: none;
    &.open {
      display: block;
    }
  }

  &__close {
    border: 1px solid #bac7de;
    background-color: transparent;
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    flex-shrink: 0;
    svg {
      width: 8px;
      height: 8px;
    }
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    gap: 20px;

    @media (max-width: 768px) {
      flex-direction: row !important;
      align-items: flex-start;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
  }

  &__text {
    font-size: 16px;
  }
}
</style>
